const SecondaryTransportation = () => {
    return (
      <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Secondary Transportation
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Lower volume movements from an organisation’s delivery warehouse to its customers involve secondary 
              transportation. Whether a business requires multi-drop deliveries, to the regular fixed locations, or simple 
              retail store deliveries that vary every day, TCS secondary transport movements offer opportunities for 
              businesses to increase their footprints. With over 2,500 service locations nationwide, vehicle of different 
              capacities, driver assistance, special handling procedures and time choice options, TCS covers every aspect 
              of your secondary transport movements.
            </p>
            
          </div>
          <div className="flex-1 flex flex-col justify-center items-center lg:mt-[0rem] mt-[1rem]">
            <img src="/fleet-transportation/Secondary-Transportation-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </ div>

      </div>

    </div>
    );
  };
  
  export default SecondaryTransportation;
  